module.exports = __webpack_public_path__ + "img/cassandra.bb63f294.jpg";